import { selector } from 'recoil';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { currentTeam } from '../atoms/currentTeam';
import { businessUserTimeSavedReporting } from './businessUserTimeSavedReporting';
import { methodNameEnum } from './makePHPRequest';

const convert = (n) =>
  `0${(n / 60) ^ 0}`.slice(-2) + ':' + ('0' + (n % 60)).slice(-2);
export const timeSaved = selector({
  key: 'timeSaved',
  get: ({ get }) => {
    try {
      const result = {};
      result.stats = [];
      result.charts = [];
      const dataUsers = {
        call: methodNameEnum.GET_BUSINESS_USERS,
      };
      const BusinessUsers = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_USERS,
          payloadJsonString: JSON.stringify(dataUsers),
        })
      );
      const timeReport = get(businessUserTimeSavedReporting);
      const current = get(currentTeam);
      // Object.preventExtensions(BusinessUsers);
      // Object.preventExtensions(timeReport);
      const active =
        BusinessUsers?.response?.data?.result.filter((o) => o.isactive === 1) ||
        [];
      const editable = JSON.parse(JSON.stringify(timeReport));
      const report = editable.response.data.users;
      if (current.id !== 0) {
        active.forEach((i) => {
          if (report[i.userid] && i.teams) {
            const splitTeams = i.teams
              .split(',')
              .filter((x, i, a) => a.indexOf(x) === i);
            splitTeams.forEach((k) => {
              if (current.id === parseInt(k)) {
                const stat = JSON.parse(JSON.stringify(report[i.userid]));
                const chart = report[i.userid];
                chart.totals.email = i.email;
                result.charts.push(chart);
                stat.totals.email = i.email;
                stat.totals.userid = i.userid;
                stat.totals.total = stat.totals.total
                  ? convert(stat.totals.total)
                  : '00:00';
                stat.totals.c2c = stat.totals.c2c
                  ? convert(stat.totals.c2c)
                  : '00:00';
                stat.totals.loggedCall = stat.totals.loggedCall
                  ? convert(stat.totals.loggedCall)
                  : '00:00';
                stat.totals.incomingCall = stat.totals.incomingCall
                  ? convert(stat.totals.incomingCall)
                  : '00:00';
                stat.totals.autoSMS = stat.totals.autoSMS
                  ? convert(stat.totals.autoSMS)
                  : '00:00';
                stat.totals.smsTemplate = stat.totals.smsTemplate
                  ? convert(stat.totals.smsTemplate)
                  : '00:00';
                stat.totals.vmDrop = stat.totals.vmDrop
                  ? convert(stat.totals.vmDrop)
                  : '00:00';
                result.stats.push(stat.totals);
              }
            });
          }
        });
      } else {
        active.forEach((i) => {
          if (report[`${i.userid}`]) {
            const stat = JSON.parse(JSON.stringify(report[i.userid]));
            const chart = report[i.userid];
            chart.totals.email = i.email;
            result.charts.push(chart);
            stat.totals.email = i.email;
            stat.totals.userid = i.userid;
            stat.totals.total = stat.totals.total
              ? convert(stat.totals.total)
              : '00:00';
            stat.totals.c2c = stat.totals.c2c
              ? convert(stat.totals.c2c)
              : '00:00';
            stat.totals.loggedCall = stat.totals.loggedCall
              ? convert(stat.totals.loggedCall)
              : '00:00';
            stat.totals.incomingCall = stat.totals.incomingCall
              ? convert(stat.totals.incomingCall)
              : '00:00';
            stat.totals.autoSMS = stat.totals.autoSMS
              ? convert(stat.totals.autoSMS)
              : '00:00';
            stat.totals.smsTemplate = stat.totals.smsTemplate
              ? convert(stat.totals.smsTemplate)
              : '00:00';
            stat.totals.vmDrop = stat.totals.vmDrop
              ? convert(stat.totals.vmDrop)
              : '00:00';
            result.stats.push(stat.totals);
          }
        });
      }

      return result;
    } catch (error) {
      throw error;
    }
  },
});
